import { render, staticRenderFns } from "./CGradientBorderContainer.vue?vue&type=template&id=92a82eca&"
import script from "./CGradientBorderContainer.vue?vue&type=script&lang=ts&"
export * from "./CGradientBorderContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports